import React from "react";
import Layout from "components/Layout";
import { Button } from "@mantine/core";
import { sendTestingSms } from "./apis/sendTestApis";
// import SendListTable from "./components/SendListTable";

function MenuTestingSms() {
  return (
    <Layout title="SMS 발송 Test">
      {/* <SendListTable /> */}
      <Button variant="default" 
        onClick={() => 
          sendTestingSms(100,1)}>
        추가
      </Button>
    </Layout>
  );
}

export default MenuTestingSms;
